import { Book } from "./book";
import { Constants } from "./constants";

export class Export {
    public description: String = '';
    public bId: String = '';
    public book: Book;
    public count: Number = 0;
    public owner: String = Constants.USER;
    public from: String = Constants.USER;
    public contentURL: String = '';
    public time: Number = 0;
    public title: String = "";
    public type: String = 'export';
    public _id: any = '';
    public sender: String = Constants.USER;
    public recipients: any;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/export.ts